import React from 'react';
import { Form, Input, Row, Col, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

const AddFirmwareModal = (props) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const { TextArea } = Input;

  const handleFileChange = (event) => {
    const file = event.target.files?.[0] || null;
    form.setFieldsValue({ firmware: file });
  };

  const onFinish = (values) => {
    props.action(values.version, values.description, values.firmware);
    props.close();
  };

  return (
    <Modal
      title={t("FirmwarePage.addFirmware")}
      open={props.visible}
      onOk={() => form.submit()}
      onCancel={props.close}
    >
      <Form form={form} onFinish={onFinish} layout="vertical">
        <Row gutter={16}>
          <Col span={24} lg={24}>
            <Form.Item
              label={t("FirmwarePage.addFirmwareModal.version")}
              name="version"
              rules={[{ required: true, message: t("FirmwarePage.addFirmwareModal.versionRequired") }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24} lg={24}>
            <Form.Item
              label={t("FirmwarePage.addFirmwareModal.description")}
              name="description"
              rules={[{ required: true, message: t("FirmwarePage.addFirmwareModal.descriptionRequired") }]}
            >
              <TextArea />
            </Form.Item>
          </Col>
          <Col span={24} lg={24}>
            <Form.Item
              label={t("FirmwarePage.addFirmwareModal.file")}
              name="firmware"
              valuePropName="file"
              rules={[{ required: true, message: t("FirmwarePage.addFirmwareModal.fileRequired") }]}
            >
              <input type="file" onChange={handleFileChange} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddFirmwareModal;
